module.exports = __webpack_public_path__ + "media/night/317-f4e044b5.svg";